module.exports = __webpack_public_path__ + "./images/77be84a6fbf5344a73419ab348f466b9.webp";